import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateTransitionsSearch } from "./-search-params";

/**
 * Pathless layout route for transition/integration handoff screens.
 * Groups: sdk-transition, peer-to-peer-transition, redirection
 */
export const Route = createFileRoute("/$locale/$partner/_transitions")({
	validateSearch: validateTransitionsSearch,
	component: TransitionsLayout,
});

function TransitionsLayout() {
	return <Outlet />;
}
